<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #cityInput
          formControlName="city" 
          [matAutocomplete]="cityAC" 
          [placeholder]="'LABEL_CITY' | translate"
          (focus)="!cityAC.isOpen && getInitialValues('city')" 
          (blur)="checkAutocompleteObject(form, 'city')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_city_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="cityInput.blur(); clearForm($event)"
          *ngIf="cityInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!cityInput.value"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_city_dropdown"
          [displayWith]="displayFn" 
          #cityAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); cityInput.blur()"
          (opened)="autocompleteScroll('city','cityACRef','cityACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.city && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_city_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.province?.description + ' - ' + data.description"
            >
            {{ data.province?.description }}, {{ data.description }}
            <!-- <p *ngIf="displayDescOnly">{{ data.description }}</p> -->
          </mat-option>

          <mat-option *ngIf="loading.city" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('city').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('city').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_CITY' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>